import TemplateServiceStyleBase from '~/src/utils/template/TemplateServiceStyleBase'
import StylesCategoryListServiceInterface
  from '~/src/components/categories/category-list/styles/StylesCategoryListServiceInterface'
import { SxProps } from '@mui/material'
import { GridListItemProps } from '~/src/types/GridList'

export default class StylesCategoryListServiceStyleTwo extends TemplateServiceStyleBase implements StylesCategoryListServiceInterface {
  public getPageSx(): SxProps {
    return {}
  }

  public getGridListSxProps(): SxProps {
    return {
      p: 0,
      pt: 2,
      [this.muiTheme.breakpoints.down('md')]: {
        px: 2
      }
    }
  }

  public getGridListItemProps(): GridListItemProps {
    return {
      xl: 2,
      lg: 3,
      md: 6,
      sm: 4,
      xs: 6
    }
  }
}
